import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import { BREAKPOINT_SMALL } from 'app/styles/breakpoints';

const { gray, green } = colors.designSystem;

export const Wrapper = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0 0;
  padding: 0;
  border: none;
  min-width: 0;
`;

export const SectionLabel = styled.legend`
  width: 100%;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: ${gray[800]};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Option = styled.div<{ $expanded?: boolean }>`
  border-radius: 8px;
  overflow: hidden;
  /* borda sempre 2px (só a cor muda) para não deslocar o layout ao trocar o radio */
  border: 2px solid ${({ $expanded }) => ($expanded ? green[500] : gray[400])};
`;

export const OptionLabel = styled.label<{ $expanded?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${gray[900]};
  cursor: pointer;
  background: ${({ $expanded }) => ($expanded ? green[100] : 'transparent')};

  input[type='radio'] {
    accent-color: ${green[500]};
    flex-shrink: 0;
  }
`;

export const OptionBody = styled.div`
  padding: 16px;
  background: ${gray[0]};
`;

export const SavedCardsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SavedCardOption = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;

  input[type='radio'] {
    accent-color: ${green[500]};
    flex-shrink: 0;
    margin-top: 14px;
  }

  > div {
    flex: 1;
    min-width: 0;
  }
`;

export const NewCardFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;

  @media (max-width: ${BREAKPOINT_SMALL}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    > :first-child {
      grid-column: 1 / -1;
    }
  }
`;

export const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
  color: ${colors.red.quinary};
`;
